import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["series", "total"]

  connect() {
    this.calculate()
  }

  calculate() {
    let total = 0
    this.seriesTargets.forEach(series => {
      let subtotal = 0
      series.querySelectorAll("[data-shot]").forEach(input => {
        const points = Number(input.value)
        if (Number.isInteger(points) && points >= 0 && points <= 10) subtotal += points
      })
      series.querySelector("[data-series-total]").textContent = subtotal
      total += subtotal
    })
    this.totalTarget.textContent = total
  }
}
